<script setup lang="ts">
import { Warning, Close } from '@element-plus/icons-vue'

const BANNER_DISMISS_KEY = 'personal_space_banner_dismissed_until'

function dismissBanner() {
  const expireDate = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10)
  localStorage.setItem(BANNER_DISMISS_KEY, expireDate)
  // trigger re-render via parent
  window.dispatchEvent(new Event('banner-dismissed'))
}
</script>

<template>
  <div class="flex items-center justify-between bg-amber-50 border-b border-amber-200 px-6 py-2.5 dark:bg-amber-900/20 dark:border-amber-800">
    <div class="flex items-center gap-2 text-sm text-amber-800 dark:text-amber-200">
      <ElIcon size="16"><Warning /></ElIcon>
      <span>您正在使用个人体验版，<router-link to="/setup" class="font-semibold underline hover:text-amber-600">补全信息</router-link>可解锁更多功能</span>
    </div>
    <el-button text size="small" @click="dismissBanner">
      <ElIcon size="14"><Close /></ElIcon>
    </el-button>
  </div>
</template>
